/**
 * Typings for table states
 *
 * - Default
 * - No fastest lap (Without "Giro veloce" column)
 */

export const DEFAULT_STATE: TableStates = 'default';
export const NO_FASTEST_LAP_STATE: TableStates = 'no-fastest-lap';

export type TableStates = 'default' | 'no-fastest-lap';

export const tableStates: TableStates[] = [DEFAULT_STATE, NO_FASTEST_LAP_STATE];
